import { useRef } from 'react'
import Content from './Content'
import { OverlayPanel } from '../../..'
import { MapPanelHeader } from './MapPanelHeader'
import { ListingDetailsListing } from '../../../../types/listings'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'

import styles from './MapPanel.module.scss'

export interface MapPanelProps {
  listing: ListingDetailsListing
}

export const MapPanel = ({ listing }: MapPanelProps) => {
  const overlayRef = useRef(null)

  return (
    <OverlayPanel
      className={styles.mapPanel}
      ref={overlayRef}
      back={OVERLAY_HELPERS.listingDetailsMap.getOrigin()}
      path={OVERLAY_HELPERS.listingDetailsMap.buildPath()}
      disableAnchor
      title='no-op'
      renderTitle={() => <MapPanelHeader listing={listing} />}
      render={() => <Content listing={listing} />}
    />
  )
}
